module.exports = __webpack_public_path__ + "static/patrick-boateng-e80c1ef2a13862169e032113c1e7c02e.jpg";